import React from 'react';
import Head from 'next/head';
import PageLayout from '@/components/PageLayout';
import { getLayoutProps } from '@/utils/layout/layout';
import { getV3Gifts } from '@/api/Gifts';
import { getCMSHomepageGrid } from '@/api/cms';
import GiftsList from '@/components/Gifts/GiftsList';

import styles from '@/styles/Gifts.module.css';

export default function Gifts({ responsiveLogo, privateApiKey, initialGifts, giftsConfig }) {
  return (
    <>
      <Head>
        <title>{process.env.displayName}</title>
        <meta name="description" content={`App for ${process.env.displayName} by Wave Grocery`} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href={responsiveLogo} />
      </Head>

      <main className={styles.mainContainer}>
        <div className={styles.giftsWrapper}>
          <GiftsList initialGifts={initialGifts} giftsConfig={giftsConfig} />
        </div>
      </main>
    </>
  );
}

Gifts.getLayout = function getLayout(page) {
  return <PageLayout>{page}</PageLayout>;
};

export async function getStaticProps({ locale }) {
  const privateApiKey = process.env.NODE_ENV === 'development' ? process.env.PRIVATE_API_KEY : null;

  const [layoutProps, gifts, { data: giftsCmsResults }] = await Promise.all([
    getLayoutProps({ headerProps: { selectedIndex: 0 } }, locale),
    getV3Gifts({ available: true }, locale),
    getCMSHomepageGrid('gifts_page', locale),
  ]).catch(error => {
    console.error(`>>> getStaticProps initialGifts error: ${error}`);
  });

  const messages = {
    common: (await import(`../../../../prebuild-data/i18n/${locale}/common.json`)).default,
    gifts: (await import(`../../../../prebuild-data/i18n/${locale}/gifts.json`)).default,
  };

  return {
    props: {
      ...layoutProps,
      initialGifts: gifts || [],
      giftsConfig: giftsCmsResults?.data?.[0]?.content || null,
      messages,
    },
  };
}
